import { render, staticRenderFns } from "./PayrollPreview.vue?vue&type=template&id=0a2867e7&scoped=true"
import script from "./PayrollPreview.vue?vue&type=script&lang=js"
export * from "./PayrollPreview.vue?vue&type=script&lang=js"
import style0 from "./PayrollPreview.vue?vue&type=style&index=0&id=0a2867e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2867e7",
  null
  
)

export default component.exports